module.exports = __webpack_public_path__ + "static/img/希捷模块.b1aee54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/希捷模块.png
// module id = SKRb
// module chunks = 1